import React, { useEffect, useState } from "react";
import { Button, Row, message, Spin, Typography } from "antd";
import { GoogleOutlined } from "@ant-design/icons";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
// import logo from "../../Images/landing.svg"
import bgImage from "../../Images/job.png";
const { Title } = Typography;

/* ================= FIREBASE ================= */

const firebaseConfig = {
  apiKey: "AIzaSyA9_xkIGbR59rimDOM3JWPyenHEYV5hyVE",
  authDomain: "visual-resume-web.firebaseapp.com",
  projectId: "visual-resume-web",
  storageBucket: "visual-resume-web.firebasestorage.app",
  messagingSenderId: "278438139073",
  appId: "1:278438139073:web:98625fca931f20ee5bb040",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

/* ================= COMPONENT ================= */

export default function AuthPages() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  /* ================= AUTH STATE ================= */

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setLoading(false);
      if (user) navigate("/welcome");
    });
    return () => unsubscribe();
  }, [navigate]);

  /* ================= GOOGLE POPUP LOGIN ================= */

  const handleGoogleLogin = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      localStorage.setItem("authLoginTime", Date.now());

      message.success(`Welcome ${user.displayName}`);
      navigate("/welcome");
    } catch (err) {
      console.error(err);
      message.error("Google login failed");
    }
  };

  /* ================= GOOGLE ONE TAP ================= */

  useEffect(() => {
    if (window.google) {
      window.google.accounts.id.initialize({
        client_id:
          "YOUR_GOOGLE_CLIENT_ID.apps.googleusercontent.com",
        callback: (response) => {
          console.log("Google One Tap:", response);
        },
      });

      window.google.accounts.id.prompt();
    }
  }, []);

  /* ================= LOADING ================= */

  if (loading) {
    return (
      <Row justify="center" align="middle" style={{ minHeight: "100vh" }}>
        <Spin size="large" />
      </Row>
    );
  }

  return (
  <div className="loginPage">

    {/* BACKGROUND IMAGE */}
    <div
      className="bgImage"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    />

    {/* OVERLAY */}
    <div className="overlay" />

    {/* LOGO TOP LEFT */}
    <div className="topBrand">
      {/* <img src={logo} alt="logo" /> */}
      <h1>
        Resume<span>IQ</span>
      </h1>
    </div>

    <div className="contentShell">
      <div className="heroCopy">
        <div className="eyebrow">Resume builder for premium exports</div>
        <h2>Build, edit, and download polished resumes on any screen.</h2>
        <p>
          Continue with Google to import your resume, refine every section, and
          export professional templates from one workspace.
        </p>
      </div>

      {/* LOGIN CARD */}
      <div className="loginWrapper">
        <div className="loginCard">
          <Title level={3} className="title">
            Login to your account
          </Title>

          <p className="subtitle">
            Continue with Google to access your resume workspace.
          </p>

          <Button
            icon={<GoogleOutlined />}
            block
            size="large"
            className="googleButton"
            onClick={handleGoogleLogin}
          >
            Continue with Google
          </Button>
        </div>
      </div>
    </div>

    {/* STYLES */}
    <style jsx>{`
      .loginPage {
        min-height: 100vh;
        width: 100%;
        position: relative;
        overflow: auto;
        font-family: 'Inter', sans-serif;
        background: #08111f;
      }

      /* BACKGROUND IMAGE */
      .bgImage {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
      }

      /* DARK OVERLAY */
      .overlay {
        position: absolute;
        inset: 0;
        z-index: 1;
        background:
          linear-gradient(
            115deg,
            rgba(7, 17, 31, 0.86) 0%,
            rgba(13, 24, 48, 0.76) 38%,
            rgba(15, 23, 42, 0.42) 100%
          );
      }

      /* LOGO */
      .topBrand {
        position: absolute;
        top: 32px;
        left: 32px;
        display: flex;
        align-items: center;
        gap: 12px;
        z-index: 3;
      }

      .topBrand img {
        width: 50px;
      }

      .topBrand h1 {
        color: white;
        font-size: 28px;
        font-weight: 600;
      }

      .topBrand span {
        color: #6366f1;
      }

      .contentShell {
        position: relative;
        z-index: 2;
        min-height: 100vh;
        max-width: 1180px;
        margin: 0 auto;
        padding: 104px 32px 32px;
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(360px, 440px);
        gap: 48px;
        align-items: center;
      }

      .heroCopy {
        color: #f8fafc;
        max-width: 560px;
      }

      .eyebrow {
        display: inline-flex;
        align-items: center;
        min-height: 34px;
        padding: 0 14px;
        border-radius: 999px;
        border: 1px solid rgba(148, 163, 184, 0.28);
        background: rgba(15, 23, 42, 0.36);
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: #cbd5e1;
      }

      .heroCopy h2 {
        margin: 18px 0 0;
        font-size: clamp(34px, 5vw, 56px);
        line-height: 1.02;
        font-weight: 800;
        letter-spacing: -0.04em;
      }

      .heroCopy p {
        margin: 18px 0 0;
        max-width: 520px;
        font-size: 17px;
        line-height: 1.7;
        color: rgba(226, 232, 240, 0.86);
      }

      /* LOGIN CARD */
      .loginWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .loginCard {
        width: min(100%, 440px);
        padding: 34px;
        border-radius: 24px;
        background: rgba(255, 255, 255, 0.92);
        backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.22);
        box-shadow: 0 25px 80px rgba(0, 0, 0, 0.36);
      }

      .title {
        margin-bottom: 8px !important;
        color: #111827;
      }

      .subtitle {
        margin: 0 0 24px;
        color: #475569;
        font-size: 15px;
        line-height: 1.6;
      }

      .googleButton {
        height: 50px;
        border-radius: 10px;
        font-weight: 600;
        transition: all 0.25s ease;
      }

      .googleButton:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 25px rgba(0,0,0,0.2);
      }

      @media (max-width: 1024px) {
        .contentShell {
          grid-template-columns: 1fr;
          gap: 24px;
          justify-items: center;
          text-align: center;
        }

        .heroCopy {
          max-width: 680px;
        }

        .heroCopy p {
          max-width: none;
        }
      }

      @media (max-width: 768px) {
        .loginPage {
          min-height: 100dvh;
        }

        .topBrand {
          top: 18px;
          left: 18px;
        }

        .topBrand h1 {
          font-size: 22px;
        }

        .contentShell {
          min-height: 100dvh;
          padding: 88px 16px 20px;
          gap: 18px;
          align-content: center;
        }

        .heroCopy {
          max-width: 100%;
        }

        .eyebrow {
          min-height: 30px;
          padding: 0 12px;
          font-size: 11px;
        }

        .heroCopy h2 {
          margin-top: 14px;
          font-size: clamp(28px, 9vw, 40px);
        }

        .heroCopy p {
          margin-top: 12px;
          font-size: 14px;
          line-height: 1.6;
        }

        .loginCard {
          width: 100%;
          padding: 24px 18px;
          border-radius: 20px;
        }

        .title {
          font-size: 26px !important;
        }

        .subtitle {
          margin-bottom: 18px;
          font-size: 14px;
        }

        .googleButton {
          height: 48px;
          font-size: 15px;
        }
      }

      @media (max-width: 420px) {
        .contentShell {
          padding: 82px 12px 16px;
        }

        .topBrand {
          left: 12px;
          top: 12px;
        }

        .topBrand h1 {
          font-size: 20px;
        }

        .heroCopy h2 {
          font-size: 28px;
        }

        .loginCard {
          padding: 20px 16px;
        }
      }
    `}</style>

  </div>
);
}
